'use strict';

angular.module('openDataApp')
  .controller('AccountCtrl', ['$scope', 'moment', 'ApiService', function ($scope, Moment, ApiService) {
    $scope.hasFreePlan = false;
    $scope.hasPendingPlan = false;

    var enrichAccountData = function (data) {
      var enrichedData = data;
      enrichedData.currentPlan = data.plan;
      enrichedData.currentPlan.nonExtensible = $scope.$parent.staticData.plans.normal[data.plan.title] === undefined;

      enrichedData.startDate = new Date(data.startDate);
      enrichedData.endDate = new Date(data.endDate);
      enrichedData.remainingDays = new Moment().diff(enrichedData.endDate, 'days') * -1;
      if (enrichedData.startDate.getYear() === new Date().getYear() && enrichedData.startDate.getMonth() === new Date().getMonth()) {
        enrichedData.periodStartDate = new Date(enrichedData.startDate);
        enrichedData.periodEndDate = new Moment(enrichedData.startDate).endOf('month');
      } else {
        enrichedData.periodStartDate = new Moment().startOf('month');
        enrichedData.periodEndDate = new Moment().endOf('month');
      }
      enrichedData.daysInPeriod = new Moment(enrichedData.periodEndDate).diff(enrichedData.periodStartDate, 'days');
      enrichedData.daysLeftInPeriod = new Moment(enrichedData.periodEndDate).diff(new Date(), 'days');
      enrichedData.periodPercentage = 100 - parseInt(enrichedData.daysLeftInPeriod / enrichedData.daysInPeriod * 100, 10);

      if (enrichedData.currentPlan.numberOfRequests === -1) {
        enrichedData.planTotal = "∞";
        enrichedData.normalLeft = 1;
        enrichedData.usagePercentage = 0;
        enrichedData.periodUrgency = enrichedData.usagePercentage - enrichedData.periodPercentage;
      } else {
        enrichedData.planTotal = enrichedData.currentPlan.numberOfRequests;
        enrichedData.normalLeft = enrichedData.planTotal - data.normalUsed;
        enrichedData.usagePercentage = parseInt(enrichedData.normalUsed / enrichedData.planTotal * 100, 10);
        enrichedData.periodPercentage = 100 - parseInt(enrichedData.daysLeftInPeriod / enrichedData.daysInPeriod * 100, 10);
        enrichedData.periodUrgency = enrichedData.usagePercentage - enrichedData.periodPercentage;
      }

      if ($scope.hasPendingPlan) {
        enrichedData.pendingPlan = $scope.$parent.staticData.plans.normal[data.switchPlan];
        enrichedData.pendingDate = new Date(data.switchDate);
        enrichedData.pendingEndDate = new Date(enrichedData.endDate);
        enrichedData.endDate = new Moment(enrichedData.pendingDate).subtract(1, 'day');
      }

      angular.forEach(data.history, function(value, key) {
        value.date = new Date(value.year, value.month, 0);
        value.plan = null;

        if (value.limit !== -1) {
          value.usagePercentage = value.used / value.limit * 100;
          if (isNaN(value.usagePercentage)) {
            value.usagePercentage = 0;
          }
          angular.forEach($scope.$parent.staticData.plans.normal, function(plan) {
            if (plan.numberOfRequests === value.limit) {
              value.plan = plan;
            }
          });
        } else {
          value.usagePercentage = 0;
          value.plan = {
            "title": "Enterprise"
          };
          value.limit = "∞";
        }
        if (value.plan === null) {
          value.plan = {
            title: value.limit === 100 ? "Starter" : "Onbekend"
          };
        }

        if (key === 0 && data.emergencyLeft > 0) {
          enrichedData.emergencyDays =  Math.floor(data.emergencyLeft / (data.history[0].usage / data.history[0].date.getDate()));
        }
      });

      return enrichedData;
    };

    var getAccountOverview = function () {
      ApiService.getAccountOverview()
        .then(
          function success(response) {
            if (response.data.plan.title === "Free") {
              $scope.hasFreePlan = true;
            } else if (response.data.switchPlan !== null) {
              $scope.hasPendingPlan = true;
            }
            $scope.account = enrichAccountData(response.data);
          },
          function error(response) {
            $scope.account = { failed: true };
            if (response.status === 401) {
              $scope.accountError = 'Je data kon niet worden opgehaald. Probeer opnieuw in te loggen.';
            } else {
              $scope.accountError = 'Je data kon niet worden opgehaald, dat ligt aan ons. We zijn ermee aan de slag, probeer het later nog eens.';
            }
          }
        );
      return { pending: true };
    };

    $scope.account = getAccountOverview();
  }]);
